// fw EmptyState — "nothing here" with an optional icon and action.

import React from 'react';
import { Icon } from '../../components/Icon.js';
import './EmptyState.css';

export function EmptyState({ icon, title, children, action, className = '', ...rest }) {
  return (
    <div className={['fw-empty', className].filter(Boolean).join(' ')} {...rest}>
      {icon ? <div className="fw-empty__icon"><Icon name={icon} /></div> : null}
      {title ? <div className="fw-empty__title">{title}</div> : null}
      {children ? <div className="fw-empty__body">{children}</div> : null}
      {action ? <div className="fw-empty__action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
